import { Reducer } from 'redux';

import {
  GroupActivityDetailsLoadFulfilledAction,
  GroupActivityDetailsLoadPendingAction,
  GroupActivityDetailsLoadRejectedAction,
} from '../../domains/groupActivityDetails/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import { GroupActivityDetailsEntities } from './types';

export type GroupActivityDetailsAction =
  | GroupActivityDetailsLoadFulfilledAction
  | GroupActivityDetailsLoadPendingAction
  | GroupActivityDetailsLoadRejectedAction;

const initialState: GroupActivityDetailsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupActivityDetailsEntities, GroupActivityDetailsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_ACTIVITY_DETAILS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_ACTIVITY_DETAILS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_ACTIVITY_DETAILS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupActionActivityDetails);
    default:
      return state;
  }
};

export default reducer;
